import {useMemo} from 'react'
import {type UIGamePlayerInfoSectionContentPiecesProps} from '../../UIGamePlayerInfo/index.ts'
import {type PlayerColor} from '@colonist/game-states'
import {useMechanicValidatorSettlement} from '../../../store/selectors/useMechanicValidatorSettlement.ts'
import {useMechanicValidatorRoad} from '../../../store/selectors/useMechanicValidatorRoad.ts'
import {useMechanicValidatorCity} from '../../../store/selectors/useMechanicValidatorCity.ts'
import {useMechanicValidatorShip} from '../../../store/selectors/useMechanicValidatorShip.ts'
import {useMechanicValidatorCityWall} from '../../../store/selectors/useMechanicValidatorCityWall.ts'

export const usePlayerInfoSectionContentPiecesProps = (playerColor: PlayerColor) => {
    const roadValidator = useMechanicValidatorRoad()
    const roadCount = roadValidator?.getRoadPlayerState(playerColor).bankRoadAmount
    const settlementValidator = useMechanicValidatorSettlement()
    const settlementCount = settlementValidator?.getSettlementPlayerState(playerColor).bankSettlementAmount
    const cityValidator = useMechanicValidatorCity()
    const cityCount = cityValidator?.getCityPlayerState(playerColor).bankCityAmount
    const shipValidator = useMechanicValidatorShip()
    const shipCount = shipValidator?.getShipPlayerState(playerColor).bankShipAmount
    const cityWallValidator = useMechanicValidatorCityWall()
    const cityWallCount = cityWallValidator?.getCityWallPlayerState(playerColor).bankCityWallAmount

    return useMemo<UIGamePlayerInfoSectionContentPiecesProps>(() => ({
        playerColor: playerColor,
        roadCount: roadCount,
        settlementCount: settlementCount,
        cityCount: cityCount,
        shipCount: shipCount,
        cityWallCount: cityWallCount,
    }), [playerColor, roadCount, settlementCount, cityCount, shipCount, cityWallCount])
}
